import { render } from "./ForceToCreatePartnerProperties.vue?vue&type=template&id=034b21a0&ts=true"
import script from "./ForceToCreatePartnerProperties.vue?vue&type=script&lang=ts"
export * from "./ForceToCreatePartnerProperties.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__